import { IntlShape } from "react-intl";
import { SearchFilterOption } from "../SearchDialog/SearchDialog.types";

export const getTitle = ({
  intl,
  hasMinSearchTerm,
  searchError,
}: {
  intl: IntlShape;
  hasMinSearchTerm: boolean;
  searchError: Error | null;
}): string => {
  if (searchError) {
    return intl.formatMessage({
      defaultMessage: "Something went wrong",
    });
  }
  return !hasMinSearchTerm
    ? intl.formatMessage({
        defaultMessage: "You may want to check for typos or adjust your filters. ",
      })
    : intl.formatMessage({ defaultMessage: "No results found" });
};

export const getDescription = ({
  intl,
  searchFilterValue,
  searchAcrossAllBudgets,
  budgetName,
  hasMinSearchTerm,
  searchError,
}: {
  intl: IntlShape;
  searchFilterValue: SearchFilterOption;
  searchAcrossAllBudgets: boolean;
  budgetName: string | null;
  hasMinSearchTerm: boolean;
  searchError: Error | null;
}): string => {
  if (searchError) {
    return searchError.message;
  }
  if (!hasMinSearchTerm) {
    return intl.formatMessage({
      defaultMessage: "Please type at least 3 characters to start searching...",
    });
  }
  if (searchFilterValue.supportInBudgetSearch && !searchAcrossAllBudgets) {
    return intl.formatMessage(
      {
        defaultMessage:
          "You may want to check for typos or adjust your filters. This search only looks within {budget} budget",
      },
      { budget: budgetName ? `"${budgetName}"` : intl.formatMessage({ defaultMessage: "your currently selected" }) },
    );
  } else {
    return intl.formatMessage({
      defaultMessage: "You may want to check for typos or adjust your filters. ",
    });
  }
};
